import type { Issue } from '@/types/reportApp';

// Dummy report data with status
export const initialIssues: Issue[] = [
  {
    id: '1',
    fileNames: ['WK_Ford_Puma_BX726_RFA_UK_Titled_16x9_15s_1920x1080.mov'],
    flag: 'red',
    timestamps: [{ start: '00:00:12:10', end: '00:00:12:15' }],
    description: 'Duplicated frame detected. Frame at 00:00:12:10 is identical to previous frame, causing stutter in motion.',
    status: 'pending',
  },
  {
    id: '2',
    fileNames: ['WK_Ford_Puma_BX726_RFA_UK_Titled_16x9_15s_1920x1080.mov'],
    flag: 'red',
    timestamps: [],
    description: 'Titled Master delivered in ProRes format. Required: H.264 .mov or .mp4 format for Titled Masters.',
    status: 'pending',
  },
  {
    id: '3',
    fileNames: ['WK_Ford_Puma_BX726_RFA_UK_Titled_16x9_15s_1920x1080.mov'],
    flag: 'orange',
    timestamps: [
      { start: '00:00:07:21', end: '00:00:08:03' },
      { start: '00:00:11:05', end: '00:00:11:12' }
    ],
    description: 'Static shot with 2-frame freeze appears at multiple timecodes. Is this creative? Pattern consistency suggests possible intentional hold.',
    status: 'pending',
  },
  {
    id: '4',
    fileNames: ['Puma_RFA_Master_Comp.aep'],
    flag: 'red',
    timestamps: [],
    description: 'Collected project file is missing linked media dependencies. Project cannot be reopened without media files.',
    status: 'pending',
  },
  {
    id: '5',
    fileNames: ['WK_Ford_Puma_BX726_RFA_UK_Titled_1x1_15s_1080x1080.mov'],
    flag: 'red',
    timestamps: [{ start: '00:00:08:14', end: '00:00:08:20' }],
    description: 'Visible edge artifact on car composite. Matte edge visible along left side of vehicle. Requires rotoscoping refinement.',
    status: 'pending',
  },
  {
    id: '6',
    fileNames: ['WK_Ford_Puma_BX726_RFA_UK_Titled_16x9_15s_1920x1080.mov'],
    flag: 'orange',
    timestamps: [{ start: '00:00:14:15', end: '00:00:15:00' }],
    description: 'Legal text appears on end frame overlapping Ford logo. Text is readable but placement is unusual. Verify if logo overlap is acceptable.',
    status: 'pending',
  },
];
